import { render, staticRenderFns } from "./createHome.vue?vue&type=template&id=73cfcb72&scoped=true&"
import script from "./createHome.vue?vue&type=script&lang=js&"
export * from "./createHome.vue?vue&type=script&lang=js&"
import style0 from "./createHome.vue?vue&type=style&index=0&id=73cfcb72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cfcb72",
  null
  
)

export default component.exports